"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m16.622 8.029-5.515 3.294s-.803.679-.115 1.595c0 0 .725.856 1.697 0l3.932-4.889z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.999 20.25c-4.549 0-8.249-3.701-8.249-8.251s3.7-8.249 8.249-8.249 8.251 3.701 8.251 8.249-3.702 8.251-8.251 8.251m0-15.194C8.17 5.056 5.055 8.171 5.055 12s3.115 6.945 6.944 6.945c3.83 0 6.945-3.116 6.945-6.945s-3.116-6.944-6.945-6.944"
  })]
}), 'ConsultantMypages');
//# sourceMappingURL=index.js.map